import apiClient from '../api';

export const createStyleDesign = ( data, header) => apiClient.post(`/style/guide/save/design`, data, header);
export const getStyleDesignList = ( id, header) => apiClient.get(`/style/guide/get/design/list/${id}`, header);
export const updateStyleGuideNotes = ( data, header) => apiClient.put(`/style/guide/update/note`, data, header);
export const deleteStyleDesign = ( data, header) => apiClient.put(`/style/guide/delete`, data, header);
